import {
  useArrivals,
  useDepartures,
  useInHouse,
} from "@/components/pages/settlement/hooks/useSettlement";
import { useHotel } from "@/hooks/useHotel";
import { useMemo } from "react";
import { format } from "date-fns";

export interface SettlementCountResult {
  arrivals: number;
  departures: number;
  inHouse: number;
}

export const useTodaySettlement = (enabled = true): SettlementCountResult => {
  const { hotelId } = useHotel(enabled);

  const todayDate = useMemo(() => format(new Date(), "yyyy-MM-dd"), []);

  const { total: arrivals } = useArrivals(
    {
      arrivalDate: todayDate,
    },
    hotelId,
  );

  const { total: departures } = useDepartures(
    {
      departureDate: todayDate,
    },
    hotelId,
  );

  const { total: inHouse } = useInHouse({}, hotelId);

  return {
    arrivals,
    departures,
    inHouse,
  };
};
